<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      人民南站<br>
站点介绍<br>
人民南站设于春风路与人民南路交叉路口，车站沿春风路方向布置。车站东北侧为国贸商圈，西侧则与深圳火车站高架轨道相邻，如需过对面则需经过“穿孔桥”或者火车站地下通道行走，南侧靠近罗湖海关及深圳火车站，周边有罗湖村、罗湖大厦、新都酒店、香格里拉大酒店、中国银行、南洋商业银行、招商银行、罗湖小学、罗湖中学等。罗湖口岸是深圳最早也是深圳陆路出入境最大的口岸，再加上罗湖火车站及罗湖客运站三位一体，使得周边交通情况拥堵不堪，人民南站不仅为了分担运输客流，公共区的黄色拱形天花设计使得空间感更大，足够多的售票机更是让乘客免与排队购票，让乘客能更加放松以及更好乘车体验。车站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:24	23:04	9号线	3分50秒	5分55秒<br>
文锦	06:24	00:05	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:24	23:04	9号线	4分25秒	5分55秒<br>
文锦	06:23	00:05	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:24	00:04	9号线	4分钟	5分55秒<br>
文锦	06:21	01:05	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A1出入口:<br>
敦信大厦、深圳火车站<br><br>
A2出入口:<br>
德兴大厦西侧、建设路东侧（南）、德兴茶叶世界<br><br>
B出入口:<br>
人民南路西侧（南）、广东省银行大厦、罗湖村、华民大厦<br><br>
C出入口:<br>
春风路、人民南路西侧（北）、罗湖小学<br><br>
D出入口:<br>
建设路东侧（北）<br><br>
公交换乘信息<br><br>
A2出入口:<br>
公交站名： 火车站337总站<br>
337路<br><br>
B出入口:<br>
公交站名： 人民南地铁站<br>
M205路、高峰专线73路、1路、17路、38路、82路、83路、97路<br><br>
C出入口:<br>
公交站名： 罗湖小学①<br>
211路、220路、307路、351路、M399路<br><br>
C出入口:<br>
公交站名： 罗湖小学②<br>
1路、12路、38路、215路、M152路、M401路<br><br>
D出入口:<br>
公交站名： 建设路总站<br>
M402路、M403路、M404路<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>